import { render, staticRenderFns } from "./BankAccountSidebar.vue?vue&type=template&id=143ed5f0"
import script from "./BankAccountSidebar.vue?vue&type=script&lang=js"
export * from "./BankAccountSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports